import { Country } from './country';
import { Locale } from './locale';

enum SourceId {
    US = 2801,
    CA = 2802,
    MobileUs = 2803,
    MobileCa = 2804,
}

export { SourceId };

const sourceIdToLocale: Record<string, Locale> = {
    [SourceId.US.toString()]: Locale['en-US'],
    [SourceId.CA.toString()]: Locale['en-CA'],
};

export function getSourceIdForCountry(country: Country): SourceId {
    return country === Country.US ? SourceId.US : SourceId.CA;
}

export function getLocaleBySourceId(sourceId: string): Locale {
    return sourceIdToLocale[sourceId] ?? Locale['en-US'];
}
export function getCountryFromSourceId(sourceId: SourceId): Country {
    return sourceId === SourceId.US || sourceId === SourceId.MobileUs ? Country.US : Country.CA;
}
